import { Effect, Reducer } from 'umi';
import { overviewOriginType } from '../../types/performance';
import {
  getGameList,
  getGameStatsList,
  getGameListTimeline,
  getLatelyGameList,
  getCollectList,
} from '../../services/game';

const namespace = 'opinionGame';

type stateType = {
  [key: string]: any;
};

function* getGameListFactory(model: string, put: any, payload: any) {
  try {
    const res: overviewOriginType = yield getGameList({
      ...payload,
    });

    yield put({
      type: 'save',
      payload: {
        [model]: res,
      },
    });
  } catch {
    yield put({
      type: 'save',
      payload: {
        [model]: [],
      },
    });
  }
}

const customModel: {
  effects: {
    [key: string]: Effect;
  };
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    gameList: [],
    gameStatsList: [],
    gameTimelineList: [],

    changeGameList: [],
    searchGameList: [],
    collectList: [],
  },
  reducers: {
    save(state: stateType, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    getGameList({ payload }, { put }) {
      return getGameListFactory('gameList', put, payload);
    },

    getChangeGameList({ payload }, { put }) {
      return getGameListFactory('changeGameList', put, payload);
    },

    getSearchGameList({ payload }, { put }) {
      return getGameListFactory('searchGameList', put, payload);
    },

    *getLatelyGameList({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getLatelyGameList({
          ...payload,
        });

        yield put({
          type: 'save',
          payload: {
            latelyGameList: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            latelyGameList: [],
          },
        });
      }
    },

    *getCollectList({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getCollectList({
          ...payload,
        });

        yield put({
          type: 'save',
          payload: {
            collectList: res?.list,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            collectList: [],
          },
        });
      }
    },

    *getGameStatsList({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getGameStatsList({
          ...payload,
        });

        yield put({
          type: 'save',
          payload: {
            gameStatsList: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            gameStatsList: [],
          },
        });
      }
    },

    *getGameListTimeline({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getGameListTimeline({
          ...payload,
        });

        yield put({
          type: 'save',
          payload: {
            gameTimelineList: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            gameTimelineList: [],
          },
        });
      }
    },
  },
};

export default customModel;
